import { IPartialReducer } from "../../../../core/core-redux/reduxTypes";
import { FeatureInfoState } from "../../../redux/types";

export const loadFeatureInfoPartialReducer: IPartialReducer<FeatureInfoState> = (state, action) => {
    return {
        features: [...action.features],
    };
};
